// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Autocomplete, TextField } from "@mui/material";
import { noop } from "../util";

function DropdownAutocomplete({
  autoFocus,
  errorMessage,
  label,
  onBlur,
  onChange,
  optionLabel,
  options,
  placeholder,
  value,
  variant,
  ...props
}) {
  const [autocompleteLabel, setAutocompleteLabel] = useState(placeholder);
  const [inputTextValue, setInputTextValue] = useState("");

  useEffect(() => {
    setAutocompleteLabel(inputTextValue.length === 0 ? placeholder : label);
  }, [inputTextValue, label, placeholder]);

  const handleInputChange = (_, textValue) => {
    setInputTextValue(textValue);
  };

  const changeToLabel = () => {
    setAutocompleteLabel(label);
  };

  const changeToPlaceholderIfEmpty = (event) => {
    onBlur?.(event);
    if (event.target?.value?.length === 0) setAutocompleteLabel(placeholder);
  };

  return (
    <Autocomplete
      value={value}
      onChange={onChange}
      onInputChange={handleInputChange}
      onOpen={changeToLabel}
      onFocus={changeToLabel}
      onClose={changeToPlaceholderIfEmpty}
      onBlur={changeToPlaceholderIfEmpty}
      options={options}
      getOptionLabel={(option) => option[optionLabel]}
      isOptionEqualToValue={(option, val) =>
        option[optionLabel] === val[optionLabel]
      }
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus={autoFocus}
          label={autocompleteLabel}
          variant={variant}
          helperText={errorMessage}
          error={Boolean(errorMessage)}
        />
      )}
      {...{ props }}
    />
  );
}

DropdownAutocomplete.defaultProps = {
  autoFocus: false,
  variant: "outlined",
  optionLabel: "name",
  onChange: noop,
};

DropdownAutocomplete.propTypes = {
  autoFocus: PropTypes.bool,
  options: PropTypes.array,
  optionLabel: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  variant: PropTypes.string,
};

export default DropdownAutocomplete;
